/**
 * Adapta definiciones de columnas con formato react-table v7
 * al formato esperado por @tanstack/react-table v8.
 *
 * Permite que los consumidores sigan pasando columnas con
 * { Header, accessor, Cell, className, headerStyle, ... }
 * sin necesidad de migrar cada definición.
 */
export function adaptarColumnas(columnas) {
  return columnas.map((col) => {
    const def = {
      id: col.id,
      header:
        typeof col.Header === 'function'
          ? (ctx) =>
              col.Header({
                ...ctx,
                data: ctx.table.options.data,
              })
          : col.Header,
      enableColumnFilter: col.disableFilters !== true,
      filterFn: col.filter,
      meta: {
        className: col.className,
        headerStyle: col.headerStyle || col.estilosHeader,
        disableFilters: col.disableFilters,
        Filter: col.Filter,
      },
    }

    if (typeof col.accessor === 'function') {
      def.accessorFn = col.accessor
      if (!def.id) {
        def.id = col.Header || String(Math.random())
      }
    } else if (typeof col.accessor === 'string') {
      def.accessorKey = col.accessor
    }

    if (col.Cell) {
      def.cell = (info) =>
        col.Cell({
          value: info.getValue(),
          row: info.row,
          cell: info.cell,
          column: info.column,
        })
    }

    return def
  })
}
